import { OPTIONS_UPDATE_EVENT } from "../../lib/constants.js";
import { isIconSlot } from "../../lib/icons.js";
import { getControlByMemberType, getControlByValue } from "../../lib/control.js";
import _sfc_main$1 from "./option_bar_member_group.vue.js";
import { computed, createBlock, createCommentVNode, createElementBlock, createTextVNode, createVNode, nextTick, openBlock, ref, resolveComponent, resolveDirective, unref, withCtx, withDirectives } from "vue";
import { DtStack, DtTab, DtTabGroup, DtTabPanel } from "@dialpad/dialtone-vue";
import { DtIconSearch } from "@dialpad/dialtone-icons/vue";
//#region src/components/option_bar/option_bar.vue
var _hoisted_1 = { class: "dialtone-playground__controls d-ps-relative" };
var _hoisted_2 = { class: "d-fl1 d-pbs-100" };
var _sfc_main = /* @__PURE__ */ Object.assign({ name: "DtcOptionBar" }, {
	props: {
		component: {
			type: Object,
			required: true
		},
		options: {
			type: Object,
			required: true
		},
		info: {
			type: Object,
			required: true
		}
	},
	emits: [OPTIONS_UPDATE_EVENT],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const showSearch = ref(false);
		const searchInput = ref(null);
		const searchQuery = ref("");
		async function toggleSearch() {
			showSearch.value = !showSearch.value;
			if (showSearch.value) {
				await nextTick();
				searchInput.value?.$el?.querySelector("input")?.focus();
			} else searchQuery.value = "";
		}
		function normalizeForSearch(str) {
			return str.toLowerCase().replace(/[\s\-_]/g, "");
		}
		function filterMembers(members) {
			const q = normalizeForSearch(searchQuery.value);
			if (q.length < 2) return members;
			return members.filter((m) => normalizeForSearch(m.name).includes(q));
		}
		const filteredProps = computed(() => filterMembers(props.info.props));
		const filteredSlots = computed(() => filterMembers(props.info.slots));
		/**
		* Gets an array of controls for a binding.
		* Calls the utility function `getControlByMemberType(...)` which converts
		* each type for a member to a given control.
		*
		* Extra controls can be passed in as parameters.
		*
		* @param binding - The binding member.
		* @param value - The binding member value.
		* @param controls - The extra controls to allow.
		* @returns {Array} Array of a default control and valid controls.
		*/
		function getBindingControls(binding, value, ...controls) {
			const typeControls = binding.types?.map((type) => getControlByMemberType(type, binding)) ?? [];
			const validControls = [...typeControls, ...controls];
			const valueControl = getControlByValue(value);
			return [validControls, valueControl === "null" && typeControls.length > 0 ? typeControls[0] : validControls.find((control) => control === valueControl) ?? validControls[0]];
		}
		function getSlotControls(member) {
			if (isIconSlot(member)) return getStaticControl("icon-slot");
			return getStaticControl("slot");
		}
		/**
		* Forces a singular default control and valid control.
		*
		* @param control - The control to enforce.
		* @returns {Array} Array of a default control and valid control.
		*/
		function getStaticControl(control) {
			return [[control], control];
		}
		/**
		* Emits an update to a member in the 'options' data object.
		*
		* @param memberGroup - The member group
		* @param member.member
		* @param member - The member
		* @param value - The updated value
		* @param member.value
		*/
		function updateMember(memberGroup, { member, value }) {
			emit(OPTIONS_UPDATE_EVENT, (options) => {
				options[memberGroup][member] = value;
			});
		}
		function updateSlots(e) {
			updateMember("slots", e);
		}
		function updateProps(e) {
			updateMember("props", e);
		}
		return (_ctx, _cache) => {
			const _component_dt_button = resolveComponent("dt-button");
			const _component_dt_icon = resolveComponent("dt-icon");
			const _component_dt_input = resolveComponent("dt-input");
			const _directive_dt_tooltip = resolveDirective("dt-tooltip");
			const _directive_dt_scrollbar = resolveDirective("dt-scrollbar");
			return openBlock(), createElementBlock("section", _hoisted_1, [createVNode(unref(DtTabGroup), {
				size: 100,
				borderless: "",
				kind: "muted",
				"activation-mode": "auto",
				class: "d-d-flex d-fd-column d-h100p",
				"tab-list-class": "d-ps-sticky d-ibs-0 d-zi-base1 d-pie-200 d-pbs-200 d-pbe-50"
			}, {
				tabs: withCtx(() => [
					__props.info.props?.length ? (openBlock(), createBlock(unref(DtTab), {
						key: 0,
						id: "tab-props",
						"panel-id": "panel-props",
						selected: ""
					}, {
						default: withCtx(() => [..._cache[1] || (_cache[1] = [createTextVNode(" Props ", -1)])]),
						_: 1
					})) : createCommentVNode("", true),
					__props.info.slots?.length ? (openBlock(), createBlock(unref(DtTab), {
						key: 1,
						id: "tab-slots",
						"panel-id": "panel-slots"
					}, {
						default: withCtx(() => [..._cache[2] || (_cache[2] = [createTextVNode(" Slots ", -1)])]),
						_: 1
					})) : createCommentVNode("", true),
					withDirectives((openBlock(), createBlock(_component_dt_button, {
						class: "d-mis-auto",
						kind: "muted",
						importance: "clear",
						size: 100,
						active: showSearch.value,
						onClick: toggleSearch
					}, {
						icon: withCtx(({ iconSize }) => [createVNode(unref(DtIconSearch), { size: iconSize }, null, 8, ["size"])]),
						_: 1
					}, 8, ["active"])), [[_directive_dt_tooltip, "Search"]]),
					showSearch.value ? (openBlock(), createBlock(_component_dt_input, {
						key: 2,
						ref_key: "searchInput",
						ref: searchInput,
						modelValue: searchQuery.value,
						"onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => searchQuery.value = $event),
						type: "search",
						placeholder: "Search",
						size: 100,
						class: "d-w100p d-mbs-25"
					}, {
						startIcon: withCtx(({ iconSize }) => [createVNode(_component_dt_icon, {
							name: "search",
							size: iconSize
						}, null, 8, ["size"])]),
						endIcon: withCtx(({ clear }) => [createVNode(_component_dt_button, {
							kind: "muted",
							importance: "clear",
							size: 100,
							class: "d-p-25",
							"aria-label": "Clear search",
							onClick: clear
						}, {
							startIcon: withCtx(() => [createVNode(_component_dt_icon, {
								name: "close",
								size: "100"
							})]),
							_: 1
						}, 8, ["onClick"])]),
						_: 1
					}, 8, ["modelValue"])) : createCommentVNode("", true)
				]),
				default: withCtx(() => [withDirectives((openBlock(), createElementBlock("div", _hoisted_2, [createVNode(unref(DtStack), { class: "d-fl1 d-pie-200 d-pbe-200" }, {
					default: withCtx(() => [__props.info.props?.length ? (openBlock(), createBlock(unref(DtTabPanel), {
						key: 0,
						id: "panel-props",
						"tab-id": "tab-props"
					}, {
						default: withCtx(() => [__props.info.props?.length ? (openBlock(), createBlock(unref(DtStack), {
							key: 0,
							gap: "300"
						}, {
							default: withCtx(() => [createVNode(unref(DtStack), { gap: "150" }, {
								default: withCtx(() => [createVNode(_sfc_main$1, {
									component: __props.component,
									"control-selector": (prop, value) => getBindingControls(prop, value, "null"),
									members: filteredProps.value,
									values: __props.options.props,
									"exclusion-rules": __props.info.exclusions,
									"prop-values": __props.options.props,
									"member-group": "props",
									"onUpdate:member": updateProps
								}, null, 8, [
									"component",
									"control-selector",
									"members",
									"values",
									"exclusion-rules",
									"prop-values"
								])]),
								_: 1
							})]),
							_: 1
						})) : createCommentVNode("", true)]),
						_: 1
					})) : createCommentVNode("", true), __props.info.slots?.length ? (openBlock(), createBlock(unref(DtTabPanel), {
						key: 1,
						id: "panel-slots",
						"tab-id": "tab-slots"
					}, {
						default: withCtx(() => [__props.info.slots?.length ? (openBlock(), createBlock(unref(DtStack), {
							key: 0,
							gap: "300"
						}, {
							default: withCtx(() => [createVNode(unref(DtStack), { gap: "150" }, {
								default: withCtx(() => [createVNode(_sfc_main$1, {
									component: __props.component,
									"control-selector": getSlotControls,
									members: filteredSlots.value,
									values: __props.options.slots,
									"exclusion-rules": __props.info.exclusions,
									"prop-values": __props.options.props,
									"member-group": "slots",
									"onUpdate:member": updateSlots
								}, null, 8, [
									"component",
									"members",
									"values",
									"exclusion-rules",
									"prop-values"
								])]),
								_: 1
							})]),
							_: 1
						})) : createCommentVNode("", true)]),
						_: 1
					})) : createCommentVNode("", true)]),
					_: 1
				})])), [[_directive_dt_scrollbar]])]),
				_: 1
			})]);
		};
	}
});
//#endregion
export { _sfc_main as default };

//# sourceMappingURL=option_bar.vue.js.map